export default __webpack_public_path__ + "static/tarde-715acf2fa5e4c70e45c6770f6720ca51.svg";